<template>
  <div class="get-started">
    <MessageBar :message="currentMessage" :isError="isErrorMessage"></MessageBar>

    <SidebarSite :forceVisible="forceSidebarVisible"></SidebarSite>

    <Header></Header>

    <div class="get-started-content" v-on:click="closeSidebar">
      <div class="form-container" v-if="!showSuccess">
        <h1>Let's get started!</h1>
        <h2>Please provide us with a few details about you:</h2>

        <div class="message" v-bind:class="{error: validation.hasError('first_name')}">{{ validation.firstError('first_name') }}</div>
        <input type="text" v-bind:class="{errorInput: validation.hasError('first_name')}" v-model="first_name" placeholder="First Name" maxlength="20" />

        <div class="message" v-bind:class="{error: validation.hasError('last_name')}">{{ validation.firstError('last_name') }}</div>
        <input type="text" v-bind:class="{errorInput: validation.hasError('last_name')}" v-model="last_name" placeholder="Last Name" maxlength="20"/>

        <div class="message" v-bind:class="{error: validation.hasError('email')}">{{ validation.firstError('email') }}</div>
        <input type="email" v-bind:class="{errorInput: validation.hasError('email')}" v-model="email" placeholder="Email Address" maxlength="40" />

        <div class="message" v-bind:class="{error: validation.hasError('phone')}">{{ validation.firstError('phone') }}</div>
        <input type="phone" v-bind:class="{errorInput: validation.hasError('phone')}" v-model="phone" placeholder="Phone Number" maxlength="10" />

        <div class="button" v-on:click="submit">Submit</div>
      </div>

      <div class="get-started-success" v-if="showSuccess">
        <h2>Your request has processed successfully!</h2>
        <div>
          We have received your request to get started with PowerSlide. One of our representatives will get back to you within the next 24-48 hours.
        </div>

        <div class="return-home" v-on:click="goHome">
          Click here to return to the home page.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../styles/base.css'
import Footer from './Footer.vue'
import Header from './Header.vue'
import MessageBar from './MessageBar.vue'
import SidebarSite from './SidebarSite.vue'
import SimpleVueValidation from 'simple-vue-validator'

const Validator = SimpleVueValidation.Validator

export default {
  name: 'GetStarted',

  components: {
    Footer,
    Header,
    MessageBar,
    SidebarSite
  },

  data () {
    return {
      currentMessage: '',
      email: '',
      first_name: '',
      forceSidebarVisible: false,
      isErrorMessage: false,
      last_name: '',
      phone: null,
      showSuccess: false
    }
  },

  methods: {
    closeSidebar: function () {
      if (this.forceSidebarVisible) {
        this.forceSidebarVisible = false
      }
    },

    goHome: function () {
      this.$router.push('/')
    },

    resetForm: function () {
      this.email = ''
      this.first_name = ''
      this.last_name = ''
      this.phone = null
      this.validation.reset()
    },

    sendContactForm: function () {
      let data = {
        email: this.email,
        first_name: this.first_name,
        last_name: this.last_name,
        message: 'This user has submitted a get started request. Please contact them ASAP',
        phone: this.phone
      }

      this.axios.post('/api/contact', data)
        .then((response) => {
          this.$gtag.event('contact-message-sent', { method: 'Google' })
          this.setCurrentMessage('Your request has been submitted!', false)
          this.resetForm()
          this.showSuccess = true
        }).catch((err) => {
          this.setCurrentMessage(err, true)
        })
    },

    setCurrentMessage: function (message, isError) {
      this.currentMessage = message
      this.isErrorMessage = isError
    },

    submit: function () {
      this.$validate()
        .then((success) => {
          if (success) {
            this.sendContactForm()
          }
        })
    }
  },

  validators: {
    email: function (value) {
      return Validator.value(value).required().email()
    },

    first_name: function (value) {
      return Validator.value(value).required().regex('^[A-Za-z]*$', 'Can only contain alphabetic characters.')
    },

    last_name: function (value) {
      return Validator.value(value).required().regex('^[A-Za-z]*$', 'Can only contain alphabetic characters.')
    },

    phone: function (value) {
      return Validator.value(value).required().digit().length(10)
    }
  }
}
</script>

<style scoped>
  .button {
    font-size: 1.2em;
    margin-top: 1.5em;
    padding: 1em;
    width: 400px;
  }

  .form-container {
    border: 2px solid var(--light-grey);
    border-radius: 5px;
    margin: 0 auto;
    max-width: 825px;
    padding: 2em;
    text-align: center;
  }

  .get-started {
    background: var(--contact-bg);
    display: block;
    margin: 0 auto;
    position: relative;
  }

  .get-started-content {
    margin: 0 auto;
    min-height: calc(100vh - 6em);
    padding: 6em 0;
    width: 100%;
  }

  .get-started-success {
    background: white;
    margin: 3em auto;
    text-align: center;
    width: 400px;
  }

  h1 {
    margin-top: 0;
    text-align: center;
  }

  h2 {
    color: var(--secondary);
  }

  input[type=text], input[type=phone], input[type=email], textarea {
    border: 1px solid #ccc;
    display: block;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    font-size: 1.2em;
    margin: 1em auto;
    outline: none;
    padding: 1em;
    width: 400px;
  }

  .return-home {
    cursor: pointer;
    padding: 1em;
    text-align: center;
  }

  .title {
    margin-top: 70px;
  }

  @media only screen and (max-width: 400px) {
    .button {
      width: 230px !important;
    }

    .form-container {
      width: 300px !important;
    }

    input[type=text], input[type=phone], input[type=email], textarea {
      width: 230px !important;
    }
  }

  @media only screen and (max-width: 460px) {
    .button {
      width: 300px !important;
    }

    .form-container {
      width: 370px !important;
    }

    input[type=text], input[type=phone], input[type=email], textarea {
      width: 300px !important;
    }
  }

  @media only screen and (max-width: 850px) {
    .contact-content {
      border: none !important;
      padding: 6em 0em !important;
    }
  }
</style>
